enum PRODUCT_CONSTANTS {
    PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST",
    PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS",
    PRODUCT_DETAILS_FAIL = "PRODUCT_DETAILS_FAIL",

    SEARCH_PRODUCT_REQUEST = "SEARCH_PRODUCT_REQUEST",
    SEARCH_PRODUCT_SUCCESS = "SEARCH_PRODUCT_SUCCESS",
    SEARCH_PRODUCT_FAIL = "SEARCH_PRODUCT_FAIL",

    FETCH_PRODUCT_CATALOG_REQUEST = "FETCH_PRODUCT_CATALOG_REQUEST",
    FETCH_PRODUCT_CATALOG_SUCCESS = "FETCH_PRODUCT_CATALOG_SUCCESS",
    FETCH_PRODUCT_CATALOG_FAIL = "FETCH_PRODUCT_CATALOG_FAIL",

    FETCH_FRONT_PAGE_PRODUCTS_REQUEST = "FETCH_FRONT_PAGE_PRODUCTS_REQUEST",
    FETCH_FRONT_PAGE_PRODUCTS_SUCCESS = "FETCH_FRONT_PAGE_PRODUCTS_SUCCESS",
    FETCH_FRONT_PAGE_PRODUCTS_FAIL = "FETCH_FRONT_PAGE_PRODUCTS_FAIL",

    CLEAN_PRODUCT_CATALOG = "CLEAN_PRODUCT_CATALOG"
}

export default PRODUCT_CONSTANTS;